import { Breadcrumb } from './../domain/breadcrum.entity';
import { User } from '../services/auth.service';
import { ActionReducerMap } from '@ngrx/store';
import { FiltersState, filtersReducer } from './filters.reducer';
import { currentUserReducer } from './current-user.reducer';
import { breadcrumbReducer } from './breadcrumb.reducer';
import { TraxPartnersReducer, TraxPartnersState } from './traxpartners.reducer';
import { fullScreenReducer, FullScreenState } from './full-screen.reducer';
import { AppParamState, AppParamsReducer } from './app-params.reducer';
import { AppReducer, AppState } from './app.reducer';
import { printReducer, PrintState } from './print.reducer';
import { AppSettingsReducer } from './app-settings.reducer';
import { IntegrationState, IntegrationReducer } from './integration.reducer';
import { SoftwareAccessReducer, SoftwareAccessState } from './software-access.reducer';

export const appReducer: ActionReducerMap<IState> = {
  breadcrumb: breadcrumbReducer,
  currentUser: currentUserReducer,
  traxpartners: TraxPartnersReducer,
  filtersState: filtersReducer,
  fullScreen: fullScreenReducer,
  appParams: AppParamsReducer,
  app: AppReducer,
  print: printReducer,
  appSettings: AppSettingsReducer,
  integrations: IntegrationReducer,
  softwareAccess: SoftwareAccessReducer
};

export interface IState {
  appSettings: any;
  breadcrumb: Breadcrumb;
  currentUser?: User;
  traxpartners?: TraxPartnersState;
  filtersState?: FiltersState;
  fullScreen?: FullScreenState;
  appParams?: AppParamState;
  app?: AppState;
  print?: PrintState;
  integrations: IntegrationState;
  softwareAccess: SoftwareAccessState;
}
